import { render, staticRenderFns } from "./GlossaryMenu.vue?vue&type=template&id=04841e47&"
import script from "./GlossaryMenu.vue?vue&type=script&lang=js&"
export * from "./GlossaryMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports